module.exports = __webpack_public_path__ + "static/media/writeChalk.c3308ae7.mp3";